import { Translatable } from '../../../../translatable';

export enum EsploroAssetTitleType {
    MAIN = 'MAIN',
    TRANSLATION = 'TRANSLATION',
    ALTERNATIVE = 'ALTERNATIVE',
    OTHER = 'OTHER',
}

export interface EsploroAssetTitlesModel {
    titles: { [type in EsploroAssetTitleType]: EsploroAssetTitleModel };
}

export interface EsploroAssetTitleModel {
    titleType: EsploroAssetTitleType;
    titlesList: Translatable<string[]>;
    subTitlesList: Translatable<string[]>;
}
